<template>
  <div class="container flex" v-if="isShowSmokeExhaustFan">
    <div id="test" class="flex ml10">
      <div class="leftNav mt10 flex1">
        <div style="width: 98%">
          <el-input placeholder="请输入名称查询" clearable v-model="company" @blur="searchcomp" prefix-icon="el-icon-search"></el-input>
        </div>
        <div style="height: 92%; overflow: auto">
          <el-menu default-active="1-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-submenu :index="String(index + 1)" v-for="(item, index) in companyList1.length ? companyList1 : companyList" :key="index">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index + 1)}-${String(ind + 1)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="content flex1">
        <div
          class="canvas"
          ref="can1"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'relative',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousedown.stop="moveMouse"
          v-if="dwImg"
        >
          <crtmarker ref="aiPanelEditor" :isBZ="true" @added="added" :imgUrl="dwImg" />
        </div>
      </div>
      <div class="rightnav ml20 mt5" style="width: 24%; height: 91%">
        <div style="width: 100%" class="center">
          <el-col :span="24">
            <el-input placeholder="请输入部位号或名称查询" clearable v-model="rightParams.true_addr" prefix-icon="el-icon-search"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" class="ml10" style="margin-top: 0px" size="small" @click="searchRight">查询</el-button>
          </el-col>
          <el-col :span="5">
            <el-button class="ml10" style="margin-top: 0px" size="small" @click="reset">重置</el-button>
          </el-col>
        </div>
        <div style="width:100%; height:90%;overflow:auto;">
          <el-table :data="qvyuList" class="mt10" style="">
            <el-table-column prop="true_addr" label="设备名称" align="center"> </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" :type="scope.row.isMark ? 'warning' : 'primary'" icon="el-icon-edit" @click="markp(scope.row, scope.$index)"></el-button>

                <el-popconfirm title="确定删除此点位吗？" class="cursor" @confirm="cancle(scope.row)" @onConfirm="cancle(scope.row)">
                  <a slot="reference" class="red">
                    <el-button type="danger" icon="el-icon-delete" size="mini"></el-button>
                  </a>
                </el-popconfirm>
                <el-button size="mini" type="info" icon="el-icon-video-camera" plain @click="markp(scope.row, scope.$index, true)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination background v-if="rightNum > 10" layout="prev, pager, next" :page-size="rightParams.limit || 10" @current-change="pageChange" :total="rightNum">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="videoAddr + '排风机'" :visible.sync="comara">
      <div class="controlFire">
        <div class="firstControl flex">
          <div class="leftImg">
            <div class="mt10 f16 blod">{{ curObj.true_addr }}</div>

            <img class="mt10 windImg" src="@/assets/img/paifeng/fan.gif" alt="" v-if="curObj.functionState" />
            <img class="mt10 windImg" src="@/assets/img/paifeng/fan.png" v-else alt="" />
          </div>
          <div class="rightImg ">
            <div>
              <p class="f16 blod">电源状态</p>
              <!-- <div class="flex mt10 eleButon center" v-if="!(curObj.mainPowerSupply == null)"> -->

              <div class="flex mt10 center" :class="[curObj.mainPowerSupply == null || curObj.mainPowerSupply == 0 ? 'eleButon' : 'eleButonLine']">
                <span> 电源1</span>
                <div class="flex ">
                  <i :class="[curObj.mainPowerSupply == 1 ? ' workState' : 'stopState', 'closeState ml10']"></i>
                  <span class="flex ml5"> {{ curObj.mainPowerSupply == 1 ? '开' : '关' }}</span>
                </div>
              </div>

              <div class="flex mt10  center" :class="[curObj.auxiliaryPowerSupply == null || curObj.auxiliaryPowerSupply == 0 ? 'eleButon' : 'eleButonLine']">
                <span> 电源2</span>
                <div class="flex ">
                  <i :class="[curObj.auxiliaryPowerSupply == 1 ? ' workState' : 'stopState', 'closeState ml10']"></i>
                  <span class="flex ml10"> {{ curObj.auxiliaryPowerSupply == 1 ? '开' : '关' }}</span>
                </div>
              </div>
            </div>
            <div class="mt20">
              <p class="f16 blod">当前运行状态</p>
              <div class="flex">
                <i :class="[curObj.functionState == null ? 'stopState' : curObj.functionState == 0 ? 'closeState' : 'workState', 'closeState']"></i
                ><span class="flex ml5"> 运行</span>
                <i :class="[curObj.functionState == null ? 'stopState' : curObj.functionState == 0 ? 'stopState' : 'closeState', 'closeState']" class="ml10"></i>
                <span class="ml5"> 停止</span>
              </div>
            </div>
            <div class="mt20">
              <p class="f16 blod">当前模式</p>
              <div class="flex">
                <i :class="[curObj.workModeType == null ? 'stopState' : curObj.workModeType == 0 ? 'workState' : 'closeState', 'closeState']"></i>
                <span class="flex ml5"> 自动</span>
                <i :class="[curObj.workModeType == null ? 'stopState' : curObj.workModeType == 1 ? 'workState' : 'closeState', 'closeState', 'ml10']"> </i>
                <span class="ml5"> 手动</span>
              </div>
            </div>
          </div>
        </div>
        <div class="secondControl">
          <p class="f16 blod">远程控制开关</p>
          <!-- <div style="color:#F23742" v-if="curObj.functionState == 1 && curObj.workModeType == 1">
            当前设备已系统启动，暂不可远程控制，请联系相关人员处理
          </div> -->
          <div class="btnCont flex mt10 " v-if="!(curObj.functionState == 1 && curObj.workModeManual == 1)">
            <div :class="[curObj.functionState == 1 ? 'disabledOpen' : null, 'buttonCont', 'buttonOpen']" @click="handleChange(1)" v-hasPermi="['device:fan:start']">启动</div>
            <div
              :class="[curObj.functionState == null || curObj.functionState == 0 ? 'disabledOpen' : null, 'buttonCont', 'buttonClose']"
              @click="handleChange(0)"
              v-hasPermi="['device:fan:stop']"
            >
              停止
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import crtmarker from '../../components/crtmarker';

import { getMapByid } from '../../api/common';
import config from '../../utils/config.js';
if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsWaterPump;
} else if (process.env.NODE_ENV == 'production') {
  //线上
  var wsUrl = config.wsWaterPump;
}

export default {
  components: {
    crtmarker,
  },
  props: ['nowDevice'],
  data() {
    return {
      num: 1,
      isdraged: true,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: '', // 当前查询的公司
      companyList: [], //公司列表

      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      comara: false, //点位摄像头
      videoList: [], // 摄像头列表
      selectPoint: {}, // 选中的点位
      selectcomp: '',
      videoIndex: 0,
      playUrl: '',
      rightParams: {
        area_uuid: '',
        number: '',
        point_type: 227,
        true_addr: '',
        page: 1,
      },
      rightNum: 10,
      warning: false,
      nowMessage: {},
      videoAddr: '',
      curObj: {}, // 当前查看的设备
      form: {}, //最终确定的点位
      dwImg: '',
      radio1: '',
      nowDeviceMessage: '', // 设备信息
      isShowSmokeExhaustFan: false,
    };
  },
  watch: {
    comara(val) {
      if (!val) {
        // this.videoList = [];
        this.curObj = {};
      }
    },
    nowDeviceMessage(val) {
      if (this.curObj && val && val.deviceType == 240) {
        log(val, 'socket');
        if (this.curObj.id == val.deviceNo) {
          var obj = { ...this.curObj, ...val };
          this.curObj = obj;
        }
      }
      // this.viewcamra();
    },
  },
  created() {
    getMapByid(176).then((res) => {
      this.typeList = res.data;
    });

    // 获取单位
    this.$post('/crt/crtmenu', { type: 1 }).then((res) => {
      if (res.data.length) {
        this.isShowSmokeExhaustFan = true;
        this.companyList = res.data;
        for (var i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i].data.length) {
            this.checkCop(this.companyList[i].data[0]);
            break;
          }
        }
      } else {
        this.isShowSmokeExhaustFan = false;
        this.$message.warning('该业务尚未开通，请联系管理员');
      }
    });
  },
  mounted() {
    var me = this;
    var lockReconnect = false; //避免重复连接
    createWebSocket(); // 创建websocket
    function createWebSocket() {
      try {
        me.ws = new WebSocket(wsUrl);
        websocketInit();
      } catch (e) {
        log('catch');
        websocketReconnect(wsUrl);
      }
    }
    function websocketInit() {
      // 建立 web socket 连接成功触发事件
      me.ws.onopen = function(evt) {
        onOpen(evt);
      };
      // 断开 web socket 连接成功触发事件
      me.ws.onclose = function(evt) {
        websocketReconnect(wsUrl);
        onClose(evt);
      };
      // 接收服务端数据时触发事件
      me.ws.onmessage = function(evt) {
        onMessage(evt);
      };
      // 通信发生错误时触发
      me.ws.onerror = function(evt) {
        websocketReconnect(wsUrl);
        onError(evt);
      };
    }
    function onOpen(evt) {
      log('建立设备链接');
      //心跳检测重置
      if (!me.heartCheck.isStart) {
        me.heartCheck.start();
      }
    }
    function onClose(evt) {}
    function onMessage(evt) {
      // console.log(evt)
      if (evt.data === '"shoudao"') {
      } else {
        //！！这里接受消息 写东西
        var data = JSON.parse(evt.data);
        setTimeout(() => {
          me.nowDeviceMessage = data;
        }, 1000);
      }
      //拿到任何消息都说明当前连接是正常的
      me.heartCheck.start();
    }
    function websocketReconnect(url) {
      if (lockReconnect) {
        // 是否已经执行重连
        return;
      }
      lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt);
      var tt = setTimeout(function() {
        createWebSocket(url);
        lockReconnect = false;
      }, 5000);
    }
    //心跳检测
    me.heartCheck = {
      timeout: 5000,
      timeoutObj: null,
      serverTimeoutObj: null,
      isStart: false,
      start: function() {
        var self = this;
        this.isStart = true;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function() {
          //发送测试信息，后端收到后，返回一个消息，
          me.ws.send('fasong');
          self.serverTimeoutObj = setTimeout(function() {
            me.ws.close();
          }, self.timeout);
        }, this.timeout);
      },
    };
    function onError(evt) {
      log('通信错误：' + evt.data);
    }

    const makeConnection = () => {
      this.connection = new WebSocket(wsUrl);
      // Other logic codes here
      this.connection.onclose = () => {
        this.connection = null;
      };
    };
    if (this.connection) {
      this.connection.onclose = makeConnection;
      this.connection.close();
    } else {
      makeConnection();
    }
  },

  beforeDestroy() {
    this.ws.close();
    this.ws.onclose = function() {
      console.log('设备关闭');
    };
  },
  methods: {
    // 设备开关
    handleChange(status) {
      var _this = this;
      this.$confirm(`确认要${status ? '开启' : '关闭'}${this.curObj.true_addr}设备吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function() {
          // 设备开启
          _this.$put('/mqtt/mqttInfo/switchMQ', { deviceNo: _this.curObj.id, remark: status, deviceType: 240 }).then((res) => {
            this.$message({message: res.msg,type: "success", duration: 700,});
          });
        })
        .catch(function() {});
    },
    changeFireStatus(isWaring, item) {
      this.warning = isWaring;
      this.nowMessage = item;

      this.startAnimate();
    },

    // 重置山童
    resetAnimate() {
      var markers = document.getElementsByClassName('marker');
      for (var j = 0; j < markers.length; j++) {
        if (markers[j].classList.contains('animate')) {
          markers[j].classList.remove('animate');
        }
      }
    },

    startAnimate(isWaring) {
      if (!this.pointList.length) {
        console.log('无数据');
        return;
      }

      var indx = null;
      var item = null;

      if (!this.warning) {
        // console.log('取消闪动');
        this.resetAnimate();
        return;
      }

      if (this.warning) {
        // console.log('收到报警 准备闪动 ');

        setTimeout(() => {
          for (var i = 0; i < this.pointList.length; i++) {
            if (this.pointList[i].tag === this.nowMessage.detailAddr) {
              var animateClass = this.pointList[i].point_uuid;
              var markers = document.getElementsByClassName('marker');
              for (var j = 0; j < markers.length; j++) {
                if (markers[j].id === animateClass) {
                  console.log('匹配成功 准备闪动烟感');
                  markers[j].className += ' animate';
                  break;
                }
              }
              // console.log('markers循环结束');
              break;
            }
            // console.log('pointList 循环结束');
          }
        }, 50);

        setTimeout(() => {}, 50);
      }
    },

    pageChange(val) {
      // console.log(val)
      this.rightParams.page = val;
      this.getdwList();
    },
    reset() {
      this.rightParams.number = '';
      this.rightParams.true_addr = '';
      this.getdwList();
    },
    searchRight() {
      this.rightParams.number = this.rightParams.true_addr;
      this.getdwList();
    },

    playVideo() {},

    // 看坐标
    setQuery() {
      var name = this.isdraged ? 'none' : 'block';
      const markers = document.querySelectorAll('.g-image-op');
      for (var i = 0; i < markers.length; i++) {
        markers[i].style.display = name;
      }
    },
    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
      (this.companyList1.length > 0 ? this.companyList1 : this.companyList)?.forEach((item) => {
        item.data[0] && this.checkCop(item.data[0]);
      });
    },
    //提交
    submit() {},

    //取消标点
    cancle(it) {
      if (this.selectPoint.point_uuid) {
        this.$message.error('请先标记已选择点位！');
        return;
      }
      var obj = {
        point_uuid: it.point_uuid,
        x_axis: '',
        xa_axis: '',
        y_axis: '',
        ya_axis: '',
      };
      this.$post('crt/crtupdatedot', obj).then((res) => {
        // this.$message.success('删除成功');
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.isdraged = true;
        this.getdwList();
      });
    },
    // 标点
    markp(it, ind, camra) {
      // var data = null
      // this.$refs['aiPanelEditor'].remove()
      // this.$refs['aiPanelEditor'].getBiaozhu(this.pointList)
      this.isdraged = false;

      if (!camra) {
        this.pointList.map((item) => {
          if (item.point_uuid === it.point_uuid) {
            if (this.selectPoint.point_uuid) {
              this.$message.warning('请先标记已选择点位！');
              return;
            }
            this.selectPoint = item;
            this.$refs['aiPanelEditor'].startBiaoZhu(this.selectPoint);
          }
        });

        this.setQuery();
      }
      if (camra) {
        this.viewcamra(it, ind);
      }
    },
    viewcamra(it) {
      this.videoAddr = it.true_addr;
      this.videoList = [];
      console.log(it);
      this.$get('/crt/crtInfoByCrtId', { id: it.id }).then((res) => {
        console.log(res);
        this.curObj = { ...res.data[0], ...it };
        console.log(this.curObj);
      });
      this.comara = true;
      //   this.getVideoList(it);
    },
    getPoint() {
      // this.$refs["aiPanel-editor"].getMarker().clearData();
      // this.$refs["aiPanel-editor"].getMarker().renderData(this.pointList);
    },

    //获取点位
    getdwList() {
      this.$post('/crt/crtRightSmokeControlFan', this.rightParams).then((res) => {
        var companylist = [];
        var pointList = [];
        this.rightNum = res.data.count;
        res.data.list.map((item) => {
          var obj1 = {
            number: item.number,
            true_addr: item.device_name,
            point_uuid: item.point_uuid,
            id: item.id,
            isMark: item.x_axis ? true : false,
          };
          var obj2 = {
            tag: item.number,
            tagName: `<div>
                       部位编号：${item.number}<br/>
                       部位名称：${item.true_addr}<br/>
                       设备名称：${item.device_name}
                      </div>`,

            x: item.x_axis,
            y: item.y_axis,
            type: item.point_type,
            point_uuid: item.point_uuid,
          };
          companylist.push(obj1);
          pointList.push(obj2);
        });
        this.qvyuList = companylist;
        this.pointList = pointList;
        // this.getPoint();
        this.$refs['aiPanelEditor'].remove();
        this.$refs['aiPanelEditor'].getBiaozhu(this.pointList);
        this.changeFireStatus(this.warning, this.nowMessage);
      });
    },

    // 选择区域的点
    checkCop(it) {
      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.page = 1;
      this.dwImg = it.image_name;
      this.getdwList();
    },
    //准备完成时
    ready() {
      // console.log(this.pointList)
    },
    //更新时
    update(v) {
      if (!this.add && this.selectPoint.point_uuid) {
        // 新增的变化
        this.form = {};
        this.form = { ...this.selectPoint, ...v[0] };
      } else {
      }
    },

    added(v) {
      this.selectPoint = {};
      this.$post('/crt/crtupdatedot', v).then((res) => {
        // this.$message.success('保存成功');
        this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
        this.getdwList();
        // this.draged
        this.isdraged = !this.isdraged;
      });
    },
    //选中标点时
    selected(v) {
      this.isdraged = false;
      this.selectPoint = v;
      this.form = this.selectPoint;
    },
    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },

    //列表关闭是
    handleClose() {},
    // 列表展开是
    handleOpen() {},
    // 拖拽 目前还未使用
    moveMouse(e) {
      if (this.isdraged) {
        let odiv = this.$refs.can1; //获取目标元素
        //算出鼠标相对元素的位置
        let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX - disX;
          let top = e.clientY - disY;

          //绑定元素位置到positionX和positionY上面
          this.positionX = top;
          this.positionY = left;

          //移动当前元素
          odiv.style.left = left + 'px';
          odiv.style.top = top + 'px';
        };
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 排风机
.controlFire {
  width: 430px;
  .eleButon {
    border: 1px solid #c0c0c0;
    padding: 4px 2px;
    width: 120px;
    border-radius: 15px;
  }
  .eleButonLine {
    padding: 4px 2px;
    width: 120px;
    border-radius: 15px;
    border: 1px solid #3a94ff;
  }
  .eleButonSelect {
    border: 1px solid #78b6ff;
  }

  .closeState {
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .workState {
    background: #399022;
  }
  .stopState {
    background: #d0451b;
  }
  //  按钮禁用状态
  .disabledOpen {
    opacity: 0.5;
    // width: 50px;
    // height: 50px;
    pointer-events: none;
  }
  .leftImg {
    width: 280px;
    border: 2px solid #78b6ff;
    padding: 0 10px 10px;
  }
  .rightImg {
    width: 150px;
    border: 2px solid #78b6ff;
    border-left: none;
    padding: 10px;
  }
  .secondControl {
    // height: 90px;
    border: 2px solid #78b6ff;
    border-top: none;
    padding: 10px;

    .btnCont {
      display: flex;
      justify-content: space-around;

      .buttonCont {
        width: 60px;
        cursor: pointer;
        color: #fff;
        height: 60px;
        font-size: 16px;
        line-height: 3.8;
        text-align: center;
        letter-spacing: 2px;
        padding-left: 4px;
      }
      // .disabledOpen {
      //   opacity: 0.5;
      //   width: 40px;
      //   height: 40px;

      //   font-size: 10px;
      //   cursor: default;
      // }
    }

    .buttonOpen {
      background: repeating-radial-gradient(circle at center, #a1f1af, #399022);
    }
    .buttonClose {
      background: repeating-radial-gradient(circle at center, #ffe4d6, 30%, #eb0000);
    }
  }
}

.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}
::v-deep .animate {
  animation: warningmove 0.6s infinite;
  position: absolute !important;
  /* z-index: 999999; */
}

@keyframes warningmove {
  from {
    background: yellow;
  }
  to {
    background: #ed1c24;
  }
}
.canvas {
  display: flex;
  align-items: center;
}
.container {
  height: 100%;
  max-height: 80vh;
  width: 100%;
  flex-direction: column;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 23%;
  }
  #test {
    // border-top: 1px solid #ddd;

    height: 100%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 50%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}
.windImg {
  width: 16.25rem;
  height: 12.5rem;
  background-size: cover;
}
.ml20 {
  margin-left: 20px;
}
</style>
